import { Breadcrumbs, Typography, Link, Stack, TablePagination } from "@mui/material";
import { Link as LinkTo } from "react-router";
import { usePatrimonioItensInspecaoVerificacaoViewModel } from "../../viewModels/patrimonio_itens_inspecao_verificacao_view_model";
import { InformacoesGeraisPanel } from "./components/informacoes_gerais_panel";
import { LegendComponent } from "../../../../../common/components/legend_component";
import { LegendTagIcon } from "../../../../../common/components/legend_tag_icon";
import { LegendTagItemComponent } from "../../../../../common/components/legend_tag_item_component";
import { useMemo } from "react";
import AlertError from "../../../../../common/components/alert_error";
import BottomBar from "../../../../../common/components/bottom_bar";
import PrimaryButton from "../../../../../common/components/primary_button";
import FormContainer from "../../../../../common/components/form_container";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import DefaultFormInput from "../../../../../common/components/default_form_input";
import { CustomStyledDataGrid } from "./components/custom_styled_data_grid";
import { GenerateInspecaoPatrimonioItensColumnsDefinition } from "./columns/inspecao_patrimonio_itens";
import { InspecaoPatrimonioItensModel } from "../../../domain/models/Inspecao_patrimonio_itens";
import { PatrimonioInspecaoTopHeader } from "../../components/patrimonio_inspecao_top_header";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { BackButton } from "../../../../../common/components/back_button";
import { GenerateOcorrenciaColumnsDefinition } from "./columns/inspecao_patrimonio_ocorrencia";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { OcorrenciaInspecaoPatrimonioLista } from "../../../domain/models/ocorrencia_inspecao_patrimonio_lista";
import { OcorrenciaModal } from "./components/ocorrencia_modal";
import DeleteDialog from "../../../../../common/components/delete_dialog";

/**
 * PatrimonioItensInspecaoVerificacao
 */

export const PatrimonioItensInspecaoVerificacao = () => {
  const viewModel = usePatrimonioItensInspecaoVerificacaoViewModel();

  const inspecaoPatrimonioItensColumnsDefinition = useMemo(() => {
    return GenerateInspecaoPatrimonioItensColumnsDefinition({
      onActionOcorrencia: viewModel.handleOcorrenciaModalOpenState,
      onActionInspecao1Change: viewModel.handleInspecao1Change,
      onActionDataInspecao1Change: viewModel.handleDataInspecao1Change,
      onActionInspecao2Change: viewModel.handleInspecao2Change,
      onActionDataInspecao2Change: viewModel.handleDataInspecao2Change,
      onActionLimpar: viewModel.handleClearInspecaoPatrimonioItem,
    });
  }, [
    viewModel.handleOcorrenciaModalOpenState,
    viewModel.handleInspecao1Change,
    viewModel.handleDataInspecao1Change,
    viewModel.handleInspecao2Change,
    viewModel.handleDataInspecao2Change,
    viewModel.handleClearInspecaoPatrimonioItem,
  ]);


  const ocorrenciaColumnsDefinition = useMemo(() => {
    return GenerateOcorrenciaColumnsDefinition({
      lockFuncionarioAprovado: viewModel.lockFuncionarioAprovado,
      statusInspecaoPatrimonio: viewModel.inspecaoPatrimonio ? (viewModel.inspecaoPatrimonio.status ? 1 : 0) : null,
      onActionDownload: viewModel.handleDownloadArquivoOcorrencia,
      onActionEditar: viewModel.handleOcorrenciaModalOpenState,
      onActionDeletar: viewModel.handleDeleteOcorrenciaModalOpenState,
    });
  }, [
    viewModel.lockFuncionarioAprovado,
    viewModel.inspecaoPatrimonio,
    viewModel.handleDownloadArquivoOcorrencia,
    viewModel.handleOcorrenciaModalOpenState,
    viewModel.handleDeleteOcorrenciaModalOpenState,
  ]);

  return (
    <>
      <form onSubmit={viewModel.handleSubmit}>
        <PageTopBar>
          <ThreeSlotLayout
            rightSlot={
              <div className="flex flex-row gap-2">
                {/* <div className="w-[120px]">
                  <PrimaryButton
                    onClick={() => viewModel.handleInspecaoPatrimonioOpenState(null, true)}
                    startIcon={<DynamicIcon nameIcon="Add" size={25} className="text-white" />}>
                    Novo Item
                  </PrimaryButton>
                </div> */}

                <BackButton
                  onClick={viewModel.handleBack}
                />
              </div>
            }
          />
        </PageTopBar>

        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Home
            </Link>
            <Link underline="hover" color="inherit" component={'span'}>
              <LinkTo to={`/Patrimonio_maquinaEquip`}> Gestão de maquinas e equipamentos</LinkTo>
            </Link>
            <Link underline="hover" color="inherit" component={'span'}>
              <LinkTo to={`/Patrimonio_cadastroInspecao?id=${viewModel.idPatrimonioCentroCusto}`}>Cadastro de Checklist</LinkTo>
            </Link>
            <Link underline="hover" color="inherit" component={'span'}>
              <LinkTo to={`/PatrimonioItensInspecao_cadastro?id=${viewModel.idPatrimonioCentroCusto}&idPatrimonioMaquinaEquip=${viewModel.idPatrimonioMaquinaEquip}`}>Inspeções</LinkTo>
            </Link>
            <Typography className="text-primary-green">
              Checklist
            </Typography>
          </Breadcrumbs>

          {/**
          * ObrasTopHeader
          */}

          <PatrimonioInspecaoTopHeader
            title="Checklist"
            info={viewModel.patrimonioChecklistInfo ?? null}
            additionalHeader={
              viewModel.patrimonioChecklistInfo && (
                <div className="flex flex-row gap-8">
                  <div className="flex flex-row text-black dark:text-white items-center">
                    <span className="font-extrabold text-xl mr-2">Descrição: </span>
                    <span className="mx-1 font-base text-base">{viewModel.patrimonioChecklistInfo.descricaoInspecao}</span>
                  </div>
                  <div className="flex flex-row text-black dark:text-white items-center">
                    <span className="font-extrabold text-xl mr-2">Checklist: </span>
                    <span className="mx-1 font-base text-base">{viewModel.patrimonioChecklistInfo.descricaoChecklist}</span>
                  </div>
                </div>
              )
            }
            onReload={viewModel.handleReload}
          />

          {
            viewModel.errorMessage !== undefined
              ? (
                <div className="w-full">
                  <AlertError
                    messageErro={viewModel.errorMessage}
                    onTryAgain={viewModel.handleReload}
                  />
                </div>
              ) : (
                <>
                  {
                    (viewModel.inspecaoPatrimonio) &&
                    <InformacoesGeraisPanel
                      statusChecklistMaquinaEquip={viewModel.patrimonioChecklistInfo ? 0 : null}
                      lockFuncionarioInspecionado={viewModel.lockFuncionarioInspecionado}
                      lockFuncionarioAprovado={viewModel.lockFuncionarioAprovado}
                      patrimonioChecklistInfo={viewModel.patrimonioChecklistInfo ?? null}
                      inspecaoPatrimonio={viewModel.inspecaoPatrimonio}
                      funcionariosDropDown={viewModel.funcionariosDropdown}
                      hookForm={viewModel.hookForm}
                    />
                  }

                  <Stack spacing={0}>
                    <div className="w-full flex flex-row justify-between items-end">
                      <div className="flex flex-col flex-wrap">
                        <LegendComponent>
                          <LegendTagItemComponent
                            icon={<LegendTagIcon title='NA' bgColor="#89c4f4" />}
                            label='Não Se Aplica'
                          />

                          <LegendTagItemComponent
                            icon={<LegendTagIcon title='A' bgColor="#45b6af" />}
                            label='Aprovado'
                          />

                          <LegendTagItemComponent
                            icon={<LegendTagIcon title='R' bgColor="#f8cb00" />}
                            label='Reparo'
                          />

                          <LegendTagItemComponent
                            icon={<LegendTagIcon title='X' bgColor="#f3565d" />}
                            label='Reprovado'
                          />

                          <LegendTagItemComponent
                            icon={<LegendTagIcon title='RA' bgColor="#45b6af" />}
                            label='Reparo Aprovado'
                          />

                        </LegendComponent>
                      </div>
                    </div>

                    <CustomStyledDataGrid
                      tableName="patrimonio_itens_checklist_verificacao_inspecoes_items"
                      disableColumnMenu={false}
                      getRowId={(row: InspecaoPatrimonioItensModel) => row.idInspecaoPatrimonioItens}
                      textSize="muitoPequeno"
                      columns={inspecaoPatrimonioItensColumnsDefinition}
                      loading={viewModel.loading}
                      rows={viewModel.inspecoesPatrimonioItensLista}
                      rowCount={viewModel.inspecoesPatrimonioItensLista.length}
                      getRowHeight={() => 'auto'}
                      autoHeight={true}
                      disableRowSelectionOnClick={true}
                      disableColumnSorting={false}
                      pageSizeOptions={[10, 25, 50, 100]}
                      paginationMode="server"
                      paginationModel={{
                        page: viewModel.pagination.page,
                        pageSize: viewModel.pagination.rowsPerPage,
                      }}
                      onFillCurrentDateChange={viewModel.handleFillCurrentDateChange}
                    />

                    <TablePagination
                      component="div"
                      count={viewModel.pagination.totalItems}
                      page={viewModel.pagination.page - 1}
                      onPageChange={(_, p) => { }}
                      rowsPerPageOptions={[10, 25, 50, 100]}
                      rowsPerPage={viewModel.pagination.rowsPerPage}
                      onRowsPerPageChange={(e) => { }}
                    />
                  </Stack>

                  <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
                    <div className="w-full flex flex-col gap-2 mb-2">
                      <div className="flex flex-row items-center justify-between">
                        <h1 className="font-bold text-black dark:text-white">Ocorrências</h1>
                        <div>
                          {
                            (viewModel.inspecaoPatrimonio && viewModel.inspecaoPatrimonio.status !== 1 && !viewModel.lockFuncionarioAprovado) &&
                            <PrimaryButton
                              buttonColor="primary-green"
                              startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                              onMouseDown={e => {
                                viewModel.handleOcorrenciaModalOpenState(null, null, true);
                                e.preventDefault();
                              }}>
                              Novo Item
                            </PrimaryButton>
                          }
                        </div>
                      </div>
                    </div>

                    <div className="w-full flex flex-col">
                      <StyledDataGrid
                        tableName="patrimonio_inspecao_ocorrencias"
                        disableColumnMenu={false}
                        autoHeight={true}
                        getRowId={(row: OcorrenciaInspecaoPatrimonioLista) => row.idOcorrenciaInspecaoPatrimonio}
                        columns={ocorrenciaColumnsDefinition}
                        loading={viewModel.loading}
                        rows={viewModel.ocorrenciasLista}
                        rowCount={viewModel.ocorrenciasLista.length}
                        disableRowSelectionOnClick={true}
                        disableColumnSorting={false}
                        pageSizeOptions={[10, 25, 50, 100]}
                        paginationMode="server"
                        paginationModel={{
                          page: viewModel.paginationOcorrencias.page,
                          pageSize: viewModel.paginationOcorrencias.rowsPerPage,
                        }}
                      />

                      <TablePagination
                        component="div"
                        count={viewModel.paginationOcorrencias.totalItems}
                        page={viewModel.paginationOcorrencias.page - 1}
                        onPageChange={(_, p) => { }}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        rowsPerPage={viewModel.paginationOcorrencias.rowsPerPage}
                        onRowsPerPageChange={(e) => { }}
                      />
                    </div>
                  </div>

                  <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
                    <div className="w-full flex flex-col">
                      <FormContainer title="Observações" arrangement="fullRow" border={false}>
                        <>
                          <DefaultFormInput
                            name='observacao'
                            multiline={true}
                            rows={10}
                            readOnly={viewModel.lockFuncionarioAprovado
                              ? true : false}
                            reactHookForm={viewModel.hookForm}
                          />
                        </>
                      </FormContainer>
                    </div>
                  </div>

                </>
              )
          }
        </div >

        {/**
          * BottomBar
          */}

        <BottomBar>
          <div className="w-full h-full items-center justify-between flex p-4 gap-4">
            <div>
              {/* {
                isValidId(viewModel.idInspecaoPatrimonioItens) &&
                <PrimaryButton
                  buttonColor="yellow"
                  onClick={() => viewModel.handleOpenChangeHistory(null, null)}>
                  <span className="text-xs">
                    Historico de alterações
                  </span>
                </PrimaryButton>
              } */}
            </div>

            <div className="flex flex-row gap-4">
              {
                (viewModel.patrimonioChecklistInfo) &&
                <div className="w-[8rem]">
                  {
                    viewModel.saving
                      ? (
                        <PrimaryButton>
                          Salvando...
                        </PrimaryButton>
                      ) : (
                        <PrimaryButton
                          type="submit"
                          startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}>
                          Salvar
                        </PrimaryButton>
                      )
                  }
                </div>
              }
            </div>
          </div>
        </BottomBar>
      </form>

      {/**
        * Modals
        */}

      <OcorrenciaModal
        open={viewModel.ocorrenciaModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        inspecoesPatrimonioItens={viewModel.inspecoesPatrimonioItensLista}
        selectedInspecaoPatrimonioItem={viewModel.selectedInspecaoPatrimonioItem ?? null}
        selectedOcorrencia={viewModel.selectedOcorrencia ?? null}
        onDownload={viewModel.handleDownloadArquivoOcorrencia}
        onDeleteFile={viewModel.handleDeleteFileOcorrencia}
        onClose={() => viewModel.handleOcorrenciaModalOpenState(null, null, false)}
        onSubmit={viewModel.handleOcorrenciaSubmit}
      />

      <DeleteDialog
        open={viewModel.deleteOcorrenciaModal}
        onClose={() => viewModel.handleDeleteOcorrenciaModalOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteOcorrenciaSubmit}
      />

      {/**
        * Modal historico de alterações.
        */}

      {/* <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      /> */}

    </>
  );
}